export default {
  "openingScreen" : {
    "message" : "了解如何使用 CrxMouse 来",
    "description" : "Start game screen. Sentence finishes with the words - The Mouse Chase"
  },
  "startGame" : {
    "message" : "开始游戏",
    "description" : "Start game option - on screen 1"
  },
  "settings" : {
    "message" : "进入扩展设置页",
    "description" : "Settings option. Don't translate the word - CrxMouse - on screen 1 and 6"
  },
  "gestureList" : {
    "message" : "手势列表",
    "description" : "Gesture list option - on screen 1 and 6"
  },
  "playLater" : {
    "message" : "稍后再玩",
    "description" : "Play later option - on screen 1"
  },
  "playAgain" : {
    "message" : "再玩一次",
    "description" : "Play again option - on screen 6"
  },
  "startGameScreen0" : {
    "message" : "要开始游戏",
    "description" : "First sentence of the first screen for users that don't have CrxMouse installed - on screen 0"
  },
  "firstGestureInstructionDownload" : {
    "message" : "在 chrome 上下载 CrxMouse",
    "description" : "CrxMouse is available on Chrome extension store. This is the CTA that sends the user to CrxMouse on Chrome. Do not translate the word - CrxMouse - on screen 0"
  },
  "firstDownloadNow" : {
    "message" : "立即下载",
    "description" : "CTA to download CrxMouse - on screen 0"
  },
  "gestureInstructions1" : {
    "message" : "使用鼠标手势向下滚动",
    "description" : "gesture instructions on screen 1 of the game"
  },
  "gameReference1" : {
    "message" : "*** 开始追逐 ***",
    "description" : "reference to the mouse chase game on screen 1 of the game"
  },
  "movementInstructions1" : {
    "message" : "按住<span class='yellow-text'>右键单击</span>屏幕上的任何地方 + <span class='yellow-text'>向下</span>拖动一点 + 松手",
    "description" : "movement instructions on screen 1 of the game"
  },
  "gestureInstructions2" : {
    "message" : "使用超级拖拽手势在新标签页中打开链接",
    "description" : "gesture instructions on screen 2 of the game"
  },
  "gameReference2" : {
    "message" : "逃离怪物！！！",
    "description" : "reference to the mouse chase game on screen 2 of the game"
  },
  "movementInstructions2Part1" : {
    "message" : "按住<span class='yellow-text'>左键单击</span>",
    "description" : "movement instructions on screen 1 of the game - part 1 of the sentence"
  },
  "movementInstructions2Part2" : {
    "message" : "<a class='blue-link' href='/the-mouse-chase-2' target='_blank'>此链接</a>",
    "description" : "movement instructions on screen 1 of the game - part 2 of the sentence"
  },
  "movementInstructions2Part3" : {
    "message" : " + <span class='yellow-text'>向右</span>拖动一点 + 松手",
    "description" : "movement instructions on screen 1 of the game - part 3 of the sentence"
  },
  "gestureInstructions3" : {
    "message" : "使用鼠标手势导航到左侧选项卡",
    "description" : "gesture instructions on screen 3 of the game"
  },
  "gameReference3" : {
    "message" : "回来！公主有危险了",
    "description" : "reference to the mouse chase game on screen 3 of the game"
  },
  "movementInstructions3" : {
    "message" : "按住<span class='yellow-text'>右键单击</span>屏幕上的任何地方 + 将鼠标<span class='yellow-text'>向上并向左</span>拖动一点 + 松手",
    "description" : "movement instructions on screen 3 of the game"
  },
  "gestureInstructions4" : {
    "message" : "使用鼠标手势滚动到此页的顶部",
    "description" : "gesture instructions on screen 4 of the game"
  },
  "gameReference4" : {
    "message" : "打败猫咪到达公主身边",
    "description" : "reference to the mouse chase game on screen 4 of the game"
  },
  "movementInstructions4" : {
    "message" : "按住<span class='yellow-text'>右键单击</span>屏幕上的任何地方 + <span class='yellow-text'>向右并向上</span>拖动一点 + 松手",
    "description" : "movement instructions on screen 4 of the game"
  },
  "gestureInstructions5" : {
    "message" : "使用超级拖拽手势保存图片",
    "description" : "gesture instructions on screen 5 of the game"
  },
  "gameReference5" : {
    "message" : "您成功了！现在解救公主",
    "description" : "reference to the mouse chase game on screen 5 of the game"
  },
  "movementInstructions5" : {
    "message" : "按住<span class='yellow-text'>左键单击</span>公主图片 + <span class='yellow-text'>向下</span>拖动一点 + 松手",
    "description" : "movement instructions on screen 5 of the game"
  },
  "fifthFinishGame" : {
    "message" : "点击这里完成游戏",
    "description" : "A CTA the user needs to click in order to finish the game."
  },
  "sixthCongratulations" : {
    "message" : "<span class='white-text'>恭喜！</span>",
    "description" : "The last screen of the game when the user is congratualated for finishing the game."
  },
  "sixthCrxChampion" : {
    "message" : "<br>您现在是 CrxMouse 冠军了",
    "description" : "When translating, try to find the corresponding phrase for the phrase - CrxMouse champion, without translating the word - CrxMouse."
  },
  "soundOn" : {
    "message" : "开启声音",
    "description" : "instructions next to the sound icon when it's off"
  },
  "soundOff" : {
    "message" : "关闭声音",
    "description" : "instructions next to the sound icon when it's on"
  },
  "hearts" : {
    "message" : "玩游戏时赚取红心",
    "description" : "headline of hearts section"
  },
  "firstExistPopuptitle" : {
    "message" : "先别走！",
    "description" : "title of exit popup"
  },
  "firstExistPopupSubtitle" : {
    "message" : "这是您了解如何使用鼠标手势的机会",
    "description" : "subtitle of  of exit popup"
  },
  "firstExistPopupSubSubtitle" : {
    "message" : "（并从邪恶的猫手中拯救公主...）",
    "description" : "sub-subtitle of  of exit popup"
  },
  "firstExitPopupCTA1" : {
    "message" : "开始游戏",
    "description" : "First CTA of first exit popup"
  },
  "exitPopupsCTA2" : {
    "message" : "改为观看教程",
    "description" : "Second CTA of the exit popups"
  },
  "exitPopupsCTA3" : {
    "message" : "转到 CrxMouse 设置",
    "description" : "Third CTA of the exit popups"
  },
  "secondExistPopupCTA1" : {
    "message" : "继续游戏",
    "description" : "subtitle of the second exit popup"
  },
  "needHelpPopupTitle" : {
    "message" : "需要帮助？",
    "description" : "Title of the 'need help' popup"
  },
  "needHelpPopupSubtitle" : {
    "message" : "观看游戏",
    "description" : "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
  },
  "needHelpPopupClose" : {
    "message" : "关闭",
    "description" : "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
  },
  "settingsIcon" : {
    "message" : "设置",
    "description" : "text next to settings icon - appears in all screens"
  },
  "secondExistPopupSubtitle" : {
    "message" : "您只有另外 $NUMBER$ 个手势需要了解",
    "description" : "subtitle of the second exit popup",
    "placeholders" : {
      "number" : {
        "content" : "$1"
      }
    }
  }
}
